import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { isNullish } from '@epicuro-next/utilities';
import { Product } from 'graphql-api/gql-api-interfaces';

@Component({
  selector: 'epc-list-category-header',
  templateUrl: './list-category-header.component.html',
  styleUrls: ['./list-category-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ListCategoryHeaderComponent {
  @Input()
  public products: Product[];

  @Input()
  public index: number;

  @Input()
  public categoryKey: string;

  @HostBinding('class.visible')
  public get isVisible() {
    return !!this.header;
  }

  public get header() {
    if (isNullish(this.products) || isNullish(this.index)) return undefined;

    const previous = this.products[this.index - 1];
    const current = this.products[this.index];
    const previousCategory = previous?.attributes[this.categoryKey];
    const currentCategory = current.attributes[this.categoryKey];

    return currentCategory !== previousCategory ? currentCategory : undefined;
  }
}
